import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from 'ng2-ckeditor';
// import { AngularDateTimePickerModule } from 'angular2-datetimepicker';

import { ChipsModule } from 'primeng/chips';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CkeditorComponent } from './ckeditor/ckeditor.component';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { InboxComponent } from './inbox/inbox.component';
import { FilterPipe } from './pipes/filter.pipe';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ButtonDatetimepickerComponent } from './button-datetimepicker/button-datetimepicker.component';
import { FormsModule } from '@angular/forms';
import { FocusInputDirective } from './focus-input/focus-input.directive';
import { PeerEvaluationGridComponent } from './peer-evaluation-grid/peer-evaluation-grid.component';
import { VideoUploadBtnComponent } from './video-upload-btn/video-upload-btn.component';
import { ViewVideoModalComponent } from './view-video-modal/view-video-modal.component';
import { VideoLinkUploadModalComponent } from './video-link-upload-modal/video-link-upload-modal.component';
import { UploadedFileViewComponent } from './uploaded-file-view/uploaded-file-view.component';
import { TooltipModule } from 'ngx-tooltip';
import { SortPipe } from './pipes/sort.pipe';
import { UiSwitchModule } from 'ngx-ui-switch';
import { PublishToggleSwitchComponent } from './publish-toggle-switch/publish-toggle-switch.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { StudentNamePipe } from './pipes/student-name.pipe';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CKEditorModule,
    // AngularDateTimePickerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    ChipsModule,
    TooltipModule,
    UiSwitchModule,
    MalihuScrollbarModule.forChild()
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    ButtonDatetimepickerComponent,
    FocusInputDirective,
    PeerEvaluationGridComponent,
    VideoUploadBtnComponent,
    ViewVideoModalComponent,
    VideoLinkUploadModalComponent,
    UploadedFileViewComponent,
    SortPipe,
    PublishToggleSwitchComponent,
    StudentNamePipe
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    CkeditorComponent,
    DatetimepickerComponent,
    InboxComponent,
    FilterPipe,
    ButtonDatetimepickerComponent,
    FocusInputDirective,
    PeerEvaluationGridComponent,
    VideoUploadBtnComponent,
    ViewVideoModalComponent,
    VideoLinkUploadModalComponent,
    UploadedFileViewComponent,
    SortPipe,
    PublishToggleSwitchComponent,
    StudentNamePipe
  ],
  entryComponents: [ViewVideoModalComponent]
})
export class SharedModule { }



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/shared.module.ts